export default {
  data: () => ({
    translations: {
      name: {
        el: 'Πλάνο',
        en: 'Plan Name',
        it: 'Piano',
      },
      storeName: {
        el: 'Εμφανιζόμενο Όνομα Καταστήματος (εφαρμογή)',
        en: 'App Display Name',
        it: "Nome visualizzato dell'app",
      },
      email: {
        el: 'Email',
        en: 'Email',
        it: 'Email',
      },
      address: {
        el: 'Διεύθυνση',
        en: 'Address',
        it: 'Indirizzo',
      },
      primary_phone: {
        el: 'Τηλέφωνο',
        en: 'Primary Phone',
        it: 'Telefono',
      },
      description: {
        el: 'Περιγραφή του Πλάνου',
        en: 'Plan Description',
        it: 'Descrizione del piano',
      },
      activeCol: {
        el: 'Ενεργό',
        en: 'Active',
        it: 'Attivo',
      },
      price: {
        el: 'Ποσό',
        en: 'Plan Price',
        it: 'Importo',
      },
      currency: {
        el: '',
        en: 'Currency',
        it: '',
      },
      vat: {
        el: 'ΦΠΑ',
        en: 'VAT',
        it: 'IVA',
      },
      paymentMethod: {
        el: 'Τρόπος Πληρωμής',
        en: 'Payment Method',
        it: 'Metodo di pagamento',
      },
      paymentMethodCategory: {
        el: '',
        en: 'Payment Method Category',
        it: '',
      },
      type: {
        el: 'Τύπος Πλάνου',
        en: 'Plan Type',
        it: 'Tipo di piano',
      },
      payment: {
        el: 'Πληρωμές',
        en: 'Payment',
        it: 'Pagamenti',
      },
      nextPayment: {
        el: 'Επόμενη Πληρωμή',
        en: 'Next Payment Date',
        it: 'Prossima data di pagamento',
      },
      amount: {
        el: 'Ποσό',
        en: 'Amount',
        it: 'Importo',
      },
      options: {
        el: '',
        en: 'Options',
        it: '',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      showStoreSubscriptionInfo: {
        el: 'Εμφάνιση πληροφοριών συνδρομής καταστήματος',
        en: 'Show Store Subscription Info',
        it: "Mostra le informazioni sull'abbonamento al negozio",
      },
      storeSubscriptionInfo: {
        el: 'Πληροφορίες Συνδρομής Καταστήματος',
        en: 'Store Subscription Info',
        it: "Informazioni sull'abbonamento al negozio",
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      total: {
        el: 'Τζίρος',
        en: 'Total Revenue',
        it: 'Entrate totali',
      },
      paymentStatus: {
        el: 'Κατάσταση Πληρωμών',
        en: 'Payment Status',
        it: 'Stato di pagamento',
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Data',
      },
      period: {
        el: 'Περίοδος χρέωσης',
        en: 'Billing Period',
        it: 'Periodo di fatturazione',
      },
      pending: {
        el: 'τρέχον',
        en: 'pending',
        it: 'in attesa',
      },
      toBePaid: {
        el: '',
        en: 'to be paid',
        it: '',
      },
      paid: {
        el: 'εξοφλημένo',
        en: 'paid',
        it: 'Pagato',
      },
      unpaid: {
        el: 'ανεξόφλητo',
        en: 'unpaid',
        it: 'Pagato',
      },
      status: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Stato',
      },
      all: {
        el: 'Όλα',
        en: 'All',
        it: 'Tutti',
      },
      inactive: {
        el: 'Ανενεργό',
        en: 'Inactive',
        it: 'Inattivo',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      createdAt: {
        el: 'Δημιουργία',
        en: 'Created at',
        it: 'Creato a',
      },
      startDate: {
        el: 'Από Ημερ/νία',
        en: 'Start Date',
        it: 'Da Data',
      },
      expirationDate: {
        el: 'Επόμενη Ανανέωση',
        en: 'Renewal Date',
        it: 'Prossimo rinnovo',
      },
      storeCode: {
        el: 'Κωδικός Καταστήματος',
        en: 'Store Code',
        it: 'Codice del Negozio',
      },
      expiring: {
        el: 'Λήγει αυτόν τον μήνα',
        en: 'Expiring this month',
        it: 'Scadenza questo mese',
      },
      endDate: {
        el: 'Μέχρι Ημερ/νία',
        en: 'End Date',
        it: 'Ultimo Αppuntamento',
      },
      sureCancelSubscriptionOf: {
        el: 'Είστε σίγουροι ότι θέλετε να ακυρώσετε τη συνδρομή του',
        en: 'Are you sure you want to cancel subscription of',
        it: 'Si è sicuri di voler cancellare la sottoscrizione di',
      },
      surePayBillingOf: {
        el: 'Αλλαγή κατάστασης χρέωσης σε πληρωμένη. Συνέχεια;',
        en: 'Change billing status to paid. Continue?',
        it: 'Cambia lo stato di fatturazione in pagato. Continua?',
      },
      sureInvoiceBillingOf: {
        el: 'Πρόκειται να γίνει έκδοση τιμολογίου. Συνέχεια;',
        en: 'An invoice is about to be issued. Continue?',
        it: 'Sta per essere emessa una fattura. Continua?',
      },
      questionmark: {
        el: ';',
        en: '?',
        it: '?',
      },
      cancelSubscription: {
        el: 'Ακύρωση Συνδρομής',
        en: 'Cancel Subscription',
        it: "Annullamento dell'abbonamento",
      },
      payBilling: {
        el: 'Πληρωμή χρέωσης',
        en: 'Billing payment',
        it: 'Pagamento della fatturazione',
      },
      invoiceBilling: {
        el: 'Έκδοση τιμολογίου',
        en: 'Invoice billing',
        it: 'Fatturazione fatture',
      },
      submit: {
        el: 'Υποβολή',
        en: 'Submit',
        it: 'Invia',
      },
      changeToCompleted: {
        el: 'Αλλαγή πληρωμής σε ολοκληρωμένη',
        en: 'Change payment to completed',
        it: 'Modificare il pagamento in completato',
      },
      createInvoiceSendEmail: {
        el: 'Δημιουργία τιμολογίου και αποστολή email',
        en: 'Create Invoice and send Email',
        it: "Creare la fattura e inviare l'e-mail",
      },
      notifyPayment: {
        el: 'Ειδοποίηση σχετικά με την πληρωμή',
        en: 'Notify about payment',
        it: 'Notifica di pagamento',
      },
      viewMore: {
        el: 'Δείτε περισσότερα',
        en: 'View More',
        it: 'Per saperne di più',
      },
      billingDetails: {
        el: 'Στοιχεία Τιμολόγησης',
        en: 'Billing Details',
        it: 'Dettagli di fatturazione',
      },
      notificationSent: {
        el: 'Η ειδοποίηση στάλθηκε επιτυχώς',
        en: 'Notification sent successfully',
        it: 'Notifica inviata con successo',
      },
      notifyManager: {
        el: 'Αποστολή ειδοποίησης στον αντίστοιχο διαχειριστή σχετικά με τον κωδικό πληρωμής για την ακόλουθη τιμολόγηση',
        en: 'Send a notification to the corresponding manager about the payment code for the following billing',
        it: 'Invia una notifica al gestore corrispondente sul codice di pagamento per la seguente fatturazione',
      },
      dueDateInvoice: {
        el: 'Έκδοση τιμολογίου',
        en: 'Invoice issue',
        it: 'Emissione della fattura',
      },
      incomplete: {
        el: 'ατελής',
        en: 'incomplete',
        it: 'incompleto',
      },
      failed: {
        el: 'αποτυχία',
        en: 'failed',
        it: 'fallito',
      },
      completed: {
        el: 'ολοκληρώθηκε',
        en: 'completed',
        it: 'completato',
      },
      processing: {
        el: 'σε επεξεργασία',
        en: 'processing',
        it: 'precessione',
      },
      success: {
        el: 'Επιτυχής ',
        en: 'Successfully ',
        it: 'Riuscito ',
      },
      active_true: {
        el: 'ενεργοποίηση',
        en: 'activated',
        it: 'attivato',
      },
      active_false: {
        el: 'απενεργοποίηση',
        en: 'deactivated',
        it: 'disattivato',
      },
      cancel: {
        el: 'ακύρωση',
        en: 'cancelled',
        it: 'annullato',
      },
      due_date_invoice: {
        el: 'ενημέρωση έκδοσης τιμολογίου',
        en: 'updated invoice issue οf',
        it: "aggiornamento dell'emissione della fattura",
      },
      subscriptionFor: {
        el: ' συνδρομής για ',
        en: ' subscription for ',
        it: ' abbonamento per ',
      },
      subscriptionManagement: {
        el: 'Διαχείριση συνδρομής',
        en: 'Subscription Management',
        it: 'Gestione abbonamenti',
      },
      daysToInactiveStore: {
        el: 'Μέρες μέχρι να γίνει ανενεργό το κατάστημα',
        en: 'Days until store becomes inactive',
        it: 'Giorni fino a quando il negozio diventa inattivo',
      },
      daysToInactiveCampaigns: {
        el: 'Μέρες μέχρι να γίνουν ανενεργές οι καμπάνιες',
        en: 'Days until campaigns become inactive',
        it: 'Giorni fino a quando le campagne diventano inattive',
      },
      daysToInactivePOS: {
        el: 'Μέρες μέχρι να γίνει ανενεργό το POS',
        en: 'Days until POS becomes inactive',
        it: 'Giorni fino a quando il POS diventa inattivo',
      },
      daysToDisableSMS: {
        el: 'Μέρες μέχρι να μη στέλνονται SMS από το POS',
        en: 'Days until SMS sending from POS is disabled',
        it: 'Giorni fino a quando gli SMS dal POS sono disabilitati',
      },
      creditsGracePeriodInDays: {
        el: 'Ημέρες χάριτος για αποστολή μηνυμάτων μέσω credits όταν το υπόλοιπο είναι ανεπαρκές',
        en: 'Grace period in days for sending messages via credits when balance is insufficient',
        it: "Periodo di grazia in giorni per l'invio di messaggi tramite crediti quando il saldo è insufficiente",
      },
      invalidInput: {
        el: 'Λάθος τιμή: Πρέπει να είναι ακέραιος αριθμός ≥ 0',
        en: 'Invalid input: Must be an integer number ≥ 0',
        it: 'Valore non valido: Deve essere un numero intero ≥ 0',
      },
    },
  }),
};
